import React, { PureComponent } from 'react'
import styled from 'styled-components'
import ReactMapboxGl, { Layer, Feature, ZoomControl } from 'react-mapbox-gl'
import Marker from './Marker'
import PathNavigator from './PathNavigator'
import books from './data/books'
import legend from './data/legend'

const Map = ReactMapboxGl({
  accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
})

const lineCoordinates = books.reduce((accum, book) => {
  const { book_id } = book
  const spread = accum[book_id] ? accum[book_id] : []

  return {
    ...accum,
    [book.book_id]: [...spread, [book.lng, book.lat]],
  }
}, {})

const Wrapper = styled.section`
  width: 100vw;
  height: calc(100vh - 3rem);
`

export default class TWFMap extends PureComponent {
  state = {
    lng: -87.681,
    lat: 41.852,
    zoom: [10],
    books,
  }

  handleFlyTo = coords => {
    this.map.state.map.flyTo({ center: coords })
  }

  render() {
    const markers = books.map(book => {
      const current = legend.find(e => e.id === book.book_id)
      const coordinates = [book.lng, book.lat]

      return (
        <Marker
          key={book.id}
          book={book}
          coordinates={coordinates}
          color={current.color}
          flyTo={this.handleFlyTo}
        />
      )
    })

    const lines = legend.map((book, i) => (
      <Layer
        key={i}
        type="line"
        paint={{ 'line-color': book.color, 'line-width': 2 }}>
        <Feature coordinates={lineCoordinates[book.id]} />
      </Layer>
    ))

    return (
      <Wrapper>
        <PathNavigator
          coordinates={lineCoordinates}
          legend={legend}
          flyTo={this.handleFlyTo}
        />
        <Map
          ref={r => (this.map = r)}
          style="mapbox://styles/trevormcnaughton/ciydc45s9002a2sp5yzwau5dl" // eslint-disable-line
          center={[this.state.lng, this.state.lat]}
          zoom={this.state.zoom}
          containerStyle={{
            height: '100vh',
            width: '100vw',
          }}>
          <ZoomControl position="bottom-right" />
          {lines}
          {markers}
        </Map>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/TWFMap.js